<template>
  <div class="upload-group-edit-avatar">
    <div
      class="upload-content-edit-avatar dashed-array"
      :class="[profileSize, { 'border border-dashed border-active': isLabelShow }]"
    >
      <img
        :class="{ avatarSize, 'image-container-edit-avatar': !!avatar }"
        :src="avatar"
        @error="OnImageError"
      />
      <label class="upload-label-edit-avatar" v-if="isLabelShow">
        <div class="text-center bg-transparent text-subtitle">
          <div class="text-uppercase text-subtitle" :class="textClassHandler">
            <slot name="text" />
          </div>
        </div>
      </label>
    </div>
    <div class="upload-icon-edit-avatar">
      <div class="children-upload-plus-edit-avatar dashed-array" :class="iconSize">
        <label class="icon-background-edit-avatar"
        :style="backgroundStyle">
          <div class="text-center">
            <div class="text-uppercase text-24">
              <span v-if="type === 'add'">
                <add-icon :color="theme === 'light' ? '#292D32' : '#fff'" />
              </span>
              <span v-if="type === 'edit'">
                <edit-icon class="w-15"
                 :color="theme === 'light' ? '#292D32' : '#fff'" />
              </span>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import AddIcon from '@/assets/icons/vue/Create_Company.vue';
import EditIcon from '@/assets/icons/vue/edit.vue';
import { OnImageError } from '@/utils/on-image-error';
import { mapGetters } from 'vuex';

export default {
  name: 'EditAvatar',
  data() {
    return {
      OnImageError,
      imageSize: 150,
    };
  },
  components: { EditIcon, AddIcon },
  props: {
    size: {
      type: String,
      default: '78',
    },
    type: {
      type: String,
      required: true,
    },
    avatar: {
      type: String,
      default: '',
    },
    isLabelShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
    profileSize() {
      return `w-${this.size} h-${this.size}`;
    },
    iconSize() {
      return `w-${this.size / 3} h-${this.size / 3}`;
    },
    textClassHandler() {
      return this.uploadTextType === 'editable' ? '' : 'text-18 font-bold text-subtitle';
    },
    avatarSize() {
      return `min-w-${this.size} min-h-${this.size} max-w-${this.size} max-h-${this.size}`;
    },
    backgroundStyle() {
      if (this.theme === 'light') {
        return 'background-color : #fff';
      }
      return 'background-color : #292D32';
    },
  },
};
</script>

<style lang="css" scoped>
.upload-label-edit-avatar {
  @apply absolute flex w-full h-full cursor-pointer bg-secondary
          text-subtitle text-12 items-center justify-center;
}
.upload-content-edit-avatar {
  @apply relative flex text-center rounded-fullyRound overflow-hidden justify-center
        items-center;
}
.children-upload-plus-edit-avatar {
  @apply relative flex text-center rounded-fullyRound overflow-hidden justify-center
          items-center;
}
.upload-icon-edit-avatar {
  @apply absolute text-subtitle top-2/3 right-2/3;
}
.icon-background-edit-avatar {
  @apply absolute flex w-full h-full cursor-pointer
    text-title text-12 items-center justify-center;
}
.upload-group-edit-avatar {
  @apply relative text-center flex justify-center;
}
.image-container-edit-avatar {
  @apply transform scale-150;
}
</style>
